/*
 * Construir um Intl.NumberFormat e caro (dezenas de microssegundos) e as telas
 * de conciliacao chamam formatMoney milhares de vezes por render. O formatador
 * so depende do simbolo, entao guardamos um por simbolo e reaproveitamos.
 */
const currencyFormatters = new Map();
const decimalFormatters = new Map();

function getCurrencyFormatter(symbol) {
	const cached = currencyFormatters.get(symbol);
	if (cached) return cached;

	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: symbol,
		maximumFractionDigits: 2,
	});

	currencyFormatters.set(symbol, formatter);

	return formatter;
}

function getDecimalFormatter(symbol) {
	const cached = decimalFormatters.get(symbol);
	if (cached) return cached;

	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "decimal",
		maximumFractionDigits: 2,
	});

	decimalFormatters.set(symbol, formatter);

	return formatter;
}

export function formatMoney(value, symbol) {
	const valueToFormat = value ? value : 0;
	const currentSymbol = symbol && symbol.length > 0 ? symbol : "BRL";

	try {
		return getCurrencyFormatter(currentSymbol).format(valueToFormat);
	} catch (error) {
		/*
		 * Simbolo invalido: o Intl com style "currency" lanca na construcao, entao
		 * caimos no decimal e prefixamos o simbolo na mao.
		 */
		return `${currentSymbol} ${getDecimalFormatter(currentSymbol).format(valueToFormat)}`;
	}
}

export function inputMoneyMask(event) {
	let formatValue = event.target.value.replace(/\D/g, "");
	formatValue = (formatValue / 100).toFixed(2);
	formatValue = formatValue.replace(".", ",");
	formatValue = formatValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	return formatValue;
}

export function formatDecimal({value, decimal = 2}) {
	return Number.parseFloat(value || 0).toFixed(decimal)
}

export function formatExcelNumber(value) {
	return String(value).replace(".", ",");
}
